<template>
  <div class="py-28">
    <UiNarrowContainer>
      <ProductSlider
        id="page-product-selection"
        :products="content.products"
        :title="content.title"
        :subtitle="content.subtitle"
        show-arrows
        class="!text-left"
      />
    </UiNarrowContainer>
  </div>
</template>

<script setup lang="ts">
import type { PageProductSelectionProps } from '~/components/Page/types';

defineProps<PageProductSelectionProps>();
</script>
